const keys = {
    GET_PAGE_LIST: '/pages',
    GET_CAN_DELETE_PAGE: (page_id: number) => `/can-delete-page/${page_id}`,
    DELETE_PAGE: (page_id: number) => `/pages/${page_id}`,
    GET_PAGE_DETAILS: (page_id: number) => `/page-detail/${page_id}`,
    POST_ADD_REQUEST_PAGE: '/pages', // page , field_id , category_id , (fields of filed => store_type min,max,mid) , page_category , best_post_time=(morning , noon , afternoon , evening , night , new_page) , start_after_days , video_style_id
    PUT_UPDATE_PAGE_DETAIL: (page_id: number) => `/pages/${page_id}`,
    GET_CHECK_USERNAME: (username: string) => `/pages/check-exist/${username}`,
    GET_UPDATE_PAGE_INFO: (page: string) => `/update-page-info/${page}`,
    POST_CREATE_PROGRAMS: (page: number) => `/programs/${page}`
};

export default keys;

